import { getColorByString } from "Common/colors";
import { getCookieClientAuth } from "Common/cookies";
import noop from "lodash/noop";
import React, { useEffect, useState, useCallback, useMemo } from "react";
export const RemoteCursorsContext = React.createContext({
    cursors: [],
    setLocalCursorPosition: noop,
    localUser: undefined
});
const colors = ["#FF5733", "#33FF57", "#3357FF", "#F333FF", "#FF33A1"];
export function RemoteCursorsProvider({ provider, children }) {
    const [cursors, setCursors] = useState([]);
    const [localUser] = useState(() => {
        const user = getCookieClientAuth();
        if (user) {
            return {
                id: user.Id,
                name: user.Login,
                color: getColorByString(colors, user.Login)
            };
        }
        return undefined;
    });
    const setLocalCursorPosition = useCallback((position) => {
        if (!provider)
            return;
        if (position) {
            provider.awareness.setLocalStateField("cursor", {
                x: position.x,
                y: position.y
            });
        }
        else {
            provider.awareness.setLocalStateField("cursor", null);
        }
    }, [provider]);
    useEffect(() => {
        if (!provider)
            return;
        const handleAwarenessChange = () => {
            const states = provider.awareness.getStates();
            const remoteCursors = [];
            states.forEach((state, clientId) => {
                if (clientId === provider.awareness.clientID || !state.cursor || !state.user)
                    return;
                remoteCursors.push({
                    id: clientId.toString(),
                    position: { x: state.cursor.x, y: state.cursor.y },
                    color: state.user.color || colors[0],
                    name: state.user.name || `User${clientId}`
                });
            });
            setCursors(remoteCursors);
        };
        provider.awareness.setLocalStateField("user", localUser);
        provider.awareness.on("change", handleAwarenessChange);
        return () => {
            provider.awareness.off("change", handleAwarenessChange);
        };
    }, [provider, localUser]);
    const value = useMemo(() => ({
        cursors,
        setLocalCursorPosition,
        localUser
    }), [cursors, setLocalCursorPosition, localUser]);
    return React.createElement(RemoteCursorsContext.Provider, { value: value }, children);
}
export const useRemoteCursors = () => React.useContext(RemoteCursorsContext);
